module.exports = "<pre>{{message.payload | json}}</pre>\n"